// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2P_3h","inputWrap":"Table_inputWrap__RIQcn","col":"Table_col__jjN71","bmiTooltip":"Table_bmiTooltip__1Z7Jq"};